import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon      from "./locales/en/common";
import ruCommon      from "./locales/ru/common";
import enHome        from "./locales/en/home";
import ruHome        from "./locales/ru/home";
import enAbout       from "./locales/en/about";
import ruAbout       from "./locales/ru/about";
import enContact     from "./locales/en/contact";
import ruContact     from "./locales/ru/contact";
import enListings    from "./locales/en/listings";
import ruListings    from "./locales/ru/listings";
import enIntl        from "./locales/en/international";
import ruIntl        from "./locales/ru/international";
import enProperty    from "./locales/en/property";
import ruProperty    from "./locales/ru/property";
import enBlog        from "./locales/en/blog";
import ruBlog        from "./locales/ru/blog";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common:        enCommon,
        home:          enHome,
        about:         enAbout,
        contact:       enContact,
        listings:      enListings,
        international: enIntl,
        property:      enProperty,
        blog:          enBlog,
      },
      ru: {
        common:        ruCommon,
        home:          ruHome,
        about:         ruAbout,
        contact:       ruContact,
        listings:      ruListings,
        international: ruIntl,
        property:      ruProperty,
        blog:          ruBlog,
      },
    },

    lng:        "en",        // always start in English
    fallbackLng: "en",
    defaultNS:  "common",

    interpolation: {
      escapeValue: false,    // React already escapes
    },

    // i18next v23+ uses Intl.PluralRules by default — no extra config needed
  });

export default i18n;
